import React, { useEffect, useRef } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormFields } from '~/components/FormFields'
import { FieldComponentProps } from './types'
import { LabelWithInfo } from '../util'

const IBAN_SLUG = 'iban'

const BankAccountHolderField: React.FC<FieldComponentProps> = ({ field, name, disabled }) => {
  const { control, getValues, trigger } = useFormContext()
  const { t } = useTranslation()

  const self = getValues(name)
  const allFields = (getValues('fields') as any[]) || []
  const ibanIndex = allFields.findIndex(
    f => f?.slug === IBAN_SLUG && f?.category === self?.category && f?.farmerId === self?.farmerId
  )
  const ibanValue = ibanIndex >= 0 ? `fields[${ibanIndex}].value` : undefined

  const ownValue = useWatch({ control, name: `${name}.value` })
  const didMount = useRef(false)
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true
      return
    }
    if (ibanValue) trigger(ibanValue)
  }, [ownValue])

  const required = !disabled && Boolean(field.fieldRequired)

  const rules = {
    ...(required && {
      required: {
        value: true,
        message: t('Please enter Bank account holder')
      }
    }),
    validate: (value: string) => {
      if (disabled || value) return true
      const siblingValue = ibanValue ? getValues(ibanValue) : undefined
      if (siblingValue) {
        return t('Please enter Bank account holder')
      }
      return true
    }
  }

  return (
    <FormFields.Input
      name={`${name}.value`}
      control={control}
      disabled={disabled}
      label={<LabelWithInfo label={field.label} info={field.info} required={required} />}
      placeholder={field.placeholder}
      rules={rules}
    />
  )
}

export default BankAccountHolderField
